module.exports = __webpack_public_path__ + "img/block-feature.4bb32dfd.svg";